import { Controller } from "react-hook-form";
import { BaseField } from "./BaseField";
import { FieldProps } from "modules/record/record-producer/types/record-producer-types";
import { TextFieldInput } from "modules/record/shared/fields/TextFieldInput";
import { buildRequiredRule, getRequiredFieldMessage } from "../../services/recordProducerValidation";
import { getFieldHelperText } from "../../services/fieldHelperText";

export const TextFieldComponent = ({ column, control, baseFieldProps, runtimeProps }: FieldProps) => {
    const isMultiline = column.column_subtype === "MULTILINE";
    return (
        <BaseField column={column} required={runtimeProps?.required} hidden={runtimeProps?.hidden} {...baseFieldProps}>
            <Controller
                name={column.name}
                control={control}
                defaultValue={column.default_value || ""}
                rules={{ required: buildRequiredRule(runtimeProps?.required ?? column.is_mandatory, getRequiredFieldMessage(column)) }}
                render={({ field, fieldState }) => (
                    <TextFieldInput
                        value={field.value ?? ""}
                        onChange={field.onChange}
                        disabled={runtimeProps?.readonly}
                        multiline={isMultiline}
                        minRows={isMultiline ? 3 : 0}
                        maxRows={10}
                        error={!!fieldState.error}
                        helperText={getFieldHelperText(fieldState, runtimeProps)}
                    />
                )}
            />
        </BaseField>
    );
};
